import React, { useEffect, useRef, useState } from 'react'
import logo from '../../../assets/logos/new_logo_black_3.png';
import thai from '../../../assets/restaurant/images/thai.png';
import chinese from '../../../assets/restaurant/images/chinese.png';
import english from '../../../assets/restaurant/images/english.png';
import hindi from '../../../assets/restaurant/images/hindi.png';
import japanese from '../../../assets/restaurant/images/japanese.png';
import nepalese from '../../../assets/restaurant/images/nepalese.png';
import defaultUserProfile from '../../../assets/restaurant/images/default_user_profile.png';

import { useTranslation } from 'react-i18next'
import { getLocalKey, logOutRestaurant, setLocalKey, TrimText } from '../../../utils/commonfunction';
import { Link, NavLink, useLocation } from 'react-router-dom';
import i18next from 'i18next';
import { SOCKET_CLIENT } from '../../../utils/socket';
import { useDispatch } from 'react-redux';
import { addRestProfileData } from '../../../redux/slices/restSettings';
import { useSelector } from 'react-redux';
import { SOCKET_CLIENT_EVENTS } from '../../../utils/Constants';
import { userProfileDetails } from '../services/profile.services';
import RestaurantProfileAvatar from './components/RestaurantProfileAvatar';

export default function Header() {
  const { t } = useTranslation();
  const [flag, setFlag] = useState(getLocalKey("system_language_flag") || english);
  const [menuOpen, setMenuOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const menuRef = useRef(null);
  const menuToggleRef = useRef(null);
  const languageRef = useRef(null);
  const accountRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (!menuOpen && !languageOpen && !accountOpen) return;
      if ((menuOpen && (menuRef.current?.contains(event.target) || menuToggleRef.current?.contains(event.target)))
        || (languageOpen && languageRef.current?.contains(event.target))
        || (accountOpen && accountRef.current?.contains(event.target))) {
        return;
      }
      if (menuOpen) setMenuOpen(false);
      if (languageOpen) setLanguageOpen(false);
      if (accountOpen) setAccountOpen(false);
    };

    document.addEventListener("pointerdown", closeMenuOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeMenuOnOutsideClick);
  }, [accountOpen, languageOpen, menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
    setLanguageOpen(false);
    setAccountOpen(false);
  }, [location.pathname]);

  const changeLanguage = (lang, flag) => {
    i18next.changeLanguage(lang);
    setLocalKey("system_language", lang);
    setLocalKey("system_language_flag", flag);
    setFlag(flag);
    setLanguageOpen(false);
    const evt = new CustomEvent("language_change");
    document.dispatchEvent(evt);
  }

 
  useEffect(() => {
    userProfileDetails()
      .then((response) => dispatch(addRestProfileData(response?.data || {})))
      .catch((error) => console.error("Unable to load restaurant profile", error));
  }, [dispatch])

  const isActive=(url="/")=>{
    return window?.location?.pathname?.includes(url);
  }

  function testSocket(){
    let message = prompt("Enter message") || "Hello from socket";
    SOCKET_CLIENT.emit('testSocket', message, (error) => {
      if (error) {
        console.log("*****Socket connection error on notificationSend", error);
      }
    })
  }
  useEffect(() => {
    const handleTestSocketReply = async (response) => {
      console.log("Data", response);
    };
    const handleSocketData = async (response) => {
      console.log("Data", response);
    };

    SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.TEST_SOCKET_REPLY, handleTestSocketReply);
    SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);

    return () => {
      SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.TEST_SOCKET_REPLY, handleTestSocketReply);
      SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);
    };
  }, []);
  const restDetails = useSelector((state) => state?.restSettings?.profileData);
  const profileImage = restDetails?.profile_image || defaultUserProfile;

  // console.log(restDetails);
  return (
    <div className='header'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link to="/restaurant/dashboard" className="navbar-brand"><img src={logo} alt=''/></Link>
          <button
            ref={menuToggleRef}
            className="navbar-toggler"
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
            onClick={() => { setLanguageOpen(false); setAccountOpen(false); setMenuOpen((open) => !open); }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div ref={menuRef} className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`} id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} to={"/restaurant/dashboard"} className="nav-link" aria-current="page"><i className="ti ti-home"></i>{t("nav_link_home")}</NavLink>
              </li>
              <li className="nav-item">
              <NavLink onClick={() => setMenuOpen(false)} to={"/restaurant/sales"} className="nav-link" aria-current="page"><i className='ti ti-chart-bar'></i>{t("nav_link_sales")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} end to={"/restaurant/menu"} className={"nav-link "+(isActive('/restaurant/menu') ?" active":"")} aria-current="page"><i className='ti ti-template'></i>{t("nav_link_menu")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} end to={"/restaurant/table-management/table/1"} className={"nav-link "+(isActive('/restaurant/table-management') ?" active":"")}><i className='ti ti-brand-airtable'></i>{t("nav_link_table_management")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} end to={"/restaurant/settings/staff/1"} className={"nav-link "+(isActive('/restaurant/settings')?" active":"")} ><i className='ti ti-settings'></i>{t("nav_link_settings")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => setMenuOpen(false)} end to={"/restaurant/order-management"} className={"nav-link " +(isActive('/restaurant/order-management') ? " active" : "")}><i className='ti ti-receipt'></i>{t("nav_link_order_management")}</NavLink>
              </li>

              <li className="nav-item d-none">
                <a onClick={testSocket} className="nav-link cp">Test Socket</a>
              </li>
            </ul>
          </div>
          <div className='d-flex gap-3 restaurant-header-actions'>
            <div ref={languageRef} className="dropdown profile-dropdown lang-dropdown ">
                <button className="dropdown-toggle" type="button" aria-expanded={languageOpen} onClick={() => { setMenuOpen(false); setAccountOpen(false); setLanguageOpen((open) => !open); }}>
                  <div className='avatar avatar-xxs'>
                    <img src={flag} alt='Flag' />
                  </div>
                </button>
                <ul className={`dropdown-menu${languageOpen ? ' show' : ''}`}>
                  <li>
                    <a className="dropdown-item cp" onClick={(e) => { e.preventDefault(); changeLanguage("ja", japanese) }}>
                      <figure className='avatar avatar-xxs'>
                        <img src={japanese} alt='Japanese-flag' />
                      </figure>
                      <span>
                        Japanese
                      </span>
                    </a>
                  </li>
                  <li>
                    <Link className="dropdown-item" href="#" onClick={(e) => {e.preventDefault(); changeLanguage("en", english)}}>
                      <figure className='avatar avatar-xxs'>
                        <img src={english} alt='UK-flag' />
                      </figure>
                      <span>
                        English
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" href="#" onClick={(e) => {e.preventDefault();changeLanguage("ne", nepalese)}}>
                      <figure className='avatar avatar-xxs'>
                        <img src={nepalese} alt='Nepalese-flag' />
                      </figure>
                      <span>
                        Nepalese
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" href="#" onClick={(e) => {e.preventDefault();changeLanguage("zh", chinese)}}>
                      <figure className='avatar avatar-xxs'>
                        <img src={chinese} alt='Chinese-flag' />
                      </figure>
                      <span>
                        Chinese
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" href="#" onClick={(e) => {e.preventDefault();changeLanguage("hi", hindi)}}>
                      <figure className='avatar avatar-xxs'>
                        <img src={hindi} alt='India-flag' />
                      </figure>
                      <span>
                        Hindi
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" href="#" onClick={(e) =>{e.preventDefault();changeLanguage("th", thai)}}>
                      <figure className='avatar avatar-xxs'>
                        <img src={thai} alt='Thai-falg' />
                      </figure>
                      <span>
                        Thai
                      </span>
                    </Link>
                  </li>
                </ul>
            </div>
            <div ref={accountRef} className="profile-dropdown restaurant-account-dropdown">
                <button
                  className="dropdown-toggle restaurant-account-toggle"
                  type="button"
                  aria-expanded={accountOpen}
                  aria-haspopup="menu"
                  onClick={() => { setMenuOpen(false); setLanguageOpen(false); setAccountOpen((open) => !open); }}
                >
                  <RestaurantProfileAvatar src={profileImage} />
                  <span>{restDetails?.first_name}<i className='ti ti-chevron-down'></i></span>
                </button>
                {accountOpen && <ul className="dropdown-menu show restaurant-account-menu" role="menu">
                  <div className='profile-drop-head-out'>
                    <div className='profile-drop-head'>
                      <RestaurantProfileAvatar src={profileImage} className='mx-auto avatar avatar-xs' />
                      <figcaption>
                        <h4>{restDetails?.first_name}</h4>
                        <p>{TrimText(restDetails?.email, 22)}</p>
                      </figcaption>
                    </div>
                  </div>
                  <li>
                    <Link to={`/restaurant/profile`} className="dropdown-item" ><i className='ti ti-user'></i>{t("link_my_profile")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to={`/restaurant/profile/restaurant-profile`}><i className='ti ti-building-store'></i>{t("link_restaurant_profile")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/restaurant/profile/change-password"><i className='ti ti-lock'></i>{t("change_password")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/restaurant/profile/contract-information"><i className='ti ti-notes'></i>{t("link_contract_information")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to={`/restaurant/profile/restaurant-profile`}><i className='ti ti-chart-bar'></i> {t("fiscal_year")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/restaurant/profile/mail-notification-settings/1"><i className='ti ti-mail-opened'></i>{t("link_mail_notification_settings")}</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" onClick={(e) => { e.preventDefault(); logOutRestaurant() }}><i className='ti ti-logout'></i>{t("label_logout")}</Link>
                  </li>
                </ul>}
            </div>
          </div>
        </div>
      </nav>
      {(menuOpen || languageOpen || accountOpen) && <button className="restaurant-menu-backdrop" type="button" aria-label="Close open menu" onClick={() => { setMenuOpen(false); setLanguageOpen(false); setAccountOpen(false); }} />}
    </div>
  )
}
